module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/quote_required-866faf7c57b4bb8d43b88507f0076f02.png";